import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { GLOBAL_ERROR_HANDLING_CONFIG, GlobalErrorHandlingConfig } from 'src/app/config/AppInitializer.factory';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {
    
    constructor(@Inject(GLOBAL_ERROR_HANDLING_CONFIG) private _globalErrorHandlingConfig: GlobalErrorHandlingConfig) {
    }

    handleError(e: any): void {
        if (this._globalErrorHandlingConfig.logErrorToConsole) {
            console.error(e);
        }
    }
}